const Notify = () => {
    return(
        <div className="bg-black w-full text-white">
            <div className="max-w-[1240px] mx-auto w-full grid md:grid-cols-3 p-4 mt-20">
                <div className="mt-14">
                    <h1 className="text-xl font-bold">Wants tips and tricks to optimize your flow?</h1>
                    <p>Sign up to our newsletter and stay up to date</p>
                </div>
                <div className="md:col-span-2 mt-10">
                    <div className="flex flex-col justify-center items-center md:flex-row gap-1 col-span-2 md:justify-between md:items-center ">
                        <input className="w-full text-black border-2 mt-2 p-2 outline-0 rounded md:mt-4" type="text" placeholder="Enter ..." />
                        <button className="btn mx-auto mt-4 ">Notify Me</button>
                    </div>
                  
                        <p className="text-[12px] mt-3">We care about the protection of your data.Read our <small  className="text-green-600 ml-1 text-xs cursor-pointer">Privacy Policy</small></p>
                    
                </div>
                
            </div>
        </div>
    )
}
export default Notify